import Http from '../services/http.service';

const Dashboard = {};
Dashboard.create = async (dashboard) => (await Http.get().post(`${process.env.VUE_APP_API}/1/dashboard`, dashboard)).data;
Dashboard.summary = async (id, branch) => (await Http.get().get(`${process.env.VUE_APP_API}/1/dashboard/${id}/summary`, {params: {branch}})).data;
Dashboard.status = async (guid) => (await Http.get().get(`${process.env.VUE_APP_API}/1/dashboard/${guid}/status`)).data;
Dashboard.testSuiteStatus = async (guid) => (await Http.get().get(`${process.env.VUE_APP_API}/1/dashboard/${guid}/test-suite-status`)).data;
Dashboard.chart = async (guid) => (await Http.get().get(`${process.env.VUE_APP_API}/1/dashboard/${guid}/chart?end=${new Date().toISOString()}`)).data;
Dashboard.remove = async (guid) => (await Http.get().delete(`${process.env.VUE_APP_API}/1/dashboard/${guid}`)).data;
Dashboard.update = async (guid, dashboard) => (await Http.get().put(`${process.env.VUE_APP_API}/1/dashboard/${guid}`, dashboard)).data;
export default Dashboard;
